export default __webpack_public_path__ + "static/blob6-189df2ae515ff42ec6f9cfe39062c3ee.svg";